import { render, staticRenderFns } from "./QRCodeGroup.vue?vue&type=template&id=8dd639ea&scoped=true&"
import script from "./QRCodeGroup.vue?vue&type=script&lang=js&"
export * from "./QRCodeGroup.vue?vue&type=script&lang=js&"
import style0 from "./QRCodeGroup.vue?vue&type=style&index=0&id=8dd639ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd639ea",
  null
  
)

export default component.exports